export default __webpack_public_path__ + "static/media/cible2.7fc14b24.png";